import React from 'react';
interface Column<T> {
  key: string;
  header: string;
  render?: (item: T) => ReactNode;
  className?: string;
}
interface TableProps<T> {
  columns: Column<T>[];
  data: T[];
  keyExtractor: (item: T) => string;
  onRowClick?: (item: T) => void;
  emptyMessage?: string;
  isLoading?: boolean;
}
export function Table<T>({
  columns,
  data,
  keyExtractor,
  onRowClick,
  emptyMessage = 'No data available',
  isLoading = false
}: TableProps<T>) {
  if (isLoading) {
    return <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-212">
        <div className="animate-pulse" data-id="element-213">
          <div className="h-12 bg-gray-100 border-b border-gray-200" data-id="element-214" />
          {[...Array(5)].map((_, i) => <div key={i} className="h-16 border-b border-gray-100 flex items-center px-6 gap-4" data-id="element-215">
              <div className="h-4 bg-gray-200 rounded w-1/4" data-id="element-216" />
              <div className="h-4 bg-gray-200 rounded w-1/3" data-id="element-217" />
              <div className="h-4 bg-gray-200 rounded w-1/4" data-id="element-218" />
            </div>)}
        </div>
      </div>;
  }
  if (data.length === 0) {
    return <div className="bg-white rounded-lg border border-gray-200 p-12 text-center" data-id="element-219">
        <p className="text-gray-500" data-id="element-220">{emptyMessage}</p>
      </div>;
  }
  return <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-221">
      <div className="overflow-x-auto" data-id="element-222">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-223">
          <thead className="bg-gray-50" data-id="element-224">
            <tr data-id="element-225">
              {columns.map(column => <th key={column.key} scope="col" className={`
                    px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider
                    ${column.className || ''}
                  `} data-id="element-226">
                  {column.header}
                </th>)}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-227">
            {data.map(item => <tr key={keyExtractor(item)} onClick={() => onRowClick?.(item)} className={`
                  ${onRowClick ? 'cursor-pointer hover:bg-gray-50' : ''}
                  transition-colors duration-150
                `} data-id="element-228">
                {columns.map(column => <td key={`${keyExtractor(item)}-${column.key}`} className={`
                      px-6 py-4 whitespace-nowrap text-sm text-gray-900
                      ${column.className || ''}
                    `} data-id="element-229">
                    {column.render ? column.render(item) : (item as Record<string, unknown>)[column.key] as ReactNode}
                  </td>)}
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}